export default __webpack_public_path__ + "static/media/smart.97760a63.svg";